import React from 'react';

import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import {hasAuth} from "../../../utils/NHCore";
import {Button} from 'antd';
import css from './index.css';
import numeral from 'numeral';

/**
 * @Author: yangqizhi@ly-sky.com
 * @Description: 校内学院报到统计（按登录教师当前学院进行筛选过滤）
 */
class XnxybdtjComponent extends React.Component {

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('校内学院报到统计');
    }

    render() {

        //列参数
        const columns = [
            {
                title: '序号',
                width: '60px',
                dataIndex: 'row_id',
                fixed: 'left'
            }, {
                title: '年度',
                width: '80px',
                dataIndex: 'ND',
                key: 'nd',
                fixed: 'left',
                searchType: "select"
            }, {
                title: '学院名称',
                width: '120px',
                dataIndex: 'BMMC',
                key: 'bmmc',
                searchType: "select"
            }, {
                title: '学生类别',
                width: '80px',
                dataIndex: 'XSLB',
                key: 'xslb',
                sorted: false,
                commonSearch: false,
                searchType: "select"
            }, {
                title: '男生录取人数',
                width: '80px',
                dataIndex: 'MALELQZRS',
                key: 'malelqzrs',
                commonSearch: false,
                searchType: "input"
            }, {
                title: '女生录取人数',
                width: '80px',
                dataIndex: 'FEMALELQZRS',
                key: 'femalelqzrs',
                commonSearch: false,
                searchType: "input"
            }, {
                title: '录取总人数',
                width: '80px',
                dataIndex: 'LQZRS',
                key: 'lqzrs',
                commonSearch: false,
                searchType: "input"
            },
            {
                title: '男生报到人数',
                width: '80px',
                dataIndex: 'YBDMALEZRS',
                key: 'ybdmalezrs',
                commonSearch: false,
                searchType: "input"
            }, {
                title: '女生报到人数',
                width: '80px',
                dataIndex: 'YBDFEMALEZRS',
                key: 'ybdfemalezrs',
                commonSearch: false,
                searchType: "input"
            }, {
                title: '报到总人数',
                width: '80px',
                dataIndex: 'ZRS',
                key: 'zrs',
                commonSearch: false,
                searchType: "input"
            },
            {
                title: '报到率',
                width: '80px',
                dataIndex: 'BDL',
                commonSearch: false,
                render: (value) => {
                    return numeral(value * 100).format("0.00") + '%';
                },
                searchType: "input"
            }
        ];

        return (
          <div className={css.main_right_content} style={{height: getSize().windowH - 220}}>
              <div style={{width: '100%', height: '90%',}}>
                  <NHTable ref='nhTable'
                           sign={"zhxg_yxxt_tjcx_bdtj_xnxybdtj_filter_bm"}
                           rowKey={record=>record.row_id}
                           columns={columns}
                           sqlParams={{bmid: this.props.bmid ? this.props.bmid : ""}}
                           checkbox={false}>
                      {hasAuth("zhxg_yxgl_tjcx_bdtjcx_xy:xybdtj_export") ?
                        <Button type="primary" ghost onClick={this.handleOtpBtnClick}
                                style={{marginLeft: 10}}>导出</Button> : undefined}
                  </NHTable>
              </div>
          </div>
        )
    }

}

export default XnxybdtjComponent;


// WEBPACK FOOTER //
// ./components/tjcx/bdtjcxFilterByCollege/xnxybdtj.js